// react
import React from "react";

// components
import EmployeeCard from "../../components/EmployeeCard";

import { useUser } from "../../api/hooks";

/**
 * Augments the Employee Card by connecting it to the redux store.
 */

type AugmentedEmployeeCardProps = {
	maxWidth?: string | null;
	employeeID: string;
};

const AugmentedEmployeeCard = ({ employeeID, maxWidth }: AugmentedEmployeeCardProps) => {
	const isDetailsPage = window.location.href.indexOf("details") > -1;

	const { data: user, isLoading } = useUser({ userID: employeeID });

	return (
		<EmployeeCard
			employeeData={{
				id: employeeID,
				name: user?.name,
				jobTitle: user?.jobTitle,
				email: user?.email,
				isActive: user?.active,
			}}
			isDashboardCard={false}
			isLoading={isLoading}
			isDetailsPage={isDetailsPage}
			maxWidth={maxWidth}
		/>
	);
};

export default AugmentedEmployeeCard;
